import Model from "../../Model";

export interface TNonPaidActivity {
  applicantId: number;
  name: string;
  activityType: string;
  legalOrNatualEntity: string;
  dateFrom: string;
  dateTo: string;
  description: string;
}

export interface INonPaidActivity extends TNonPaidActivity {}

const NonPaidActivity = Model(
  (model: TNonPaidActivity): INonPaidActivity => {
    const _nonPaidActivity: TNonPaidActivity = Object.assign({}, model);

    return {
      get applicantId() {
        return _nonPaidActivity.applicantId;
      },

      get name() {
        return _nonPaidActivity.name;
      },

      get activityType() {
        return _nonPaidActivity.activityType;
      },

      get legalOrNatualEntity() {
        return _nonPaidActivity.legalOrNatualEntity;
      },

      get dateFrom() {
        return _nonPaidActivity.dateFrom;
      },

      get dateTo() {
        return _nonPaidActivity.dateTo;
      },

      get description() {
        return _nonPaidActivity.description;
      }
    };
  }
);
export default NonPaidActivity;
